<script setup>
import ApplyPunch from '@/components/ApplyPunch.vue'
import {ref} from "vue"

const today = ref(new Date())

</script>


<template>
    <ApplyPunch
        class="mb-8"
        :day="today"
    />
</template>
